import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';
import useSWR from 'swr';
import type { GetRecommendedProductResponse } from '~/api/aspida/@types';
import { useUser } from '~/api/hooks/useGetAccount';
import { getRecommendedProduct } from '~/api/recommendedProduct';
import { useRegion } from '~/features/region/hooks/useRegion';
import { useLocale } from '~/hooks/useLocale';
import { useIsFirstLogin } from '~/stores/firstLoginStore';

export const useGetRecommendedProduct = ({
  date,
}: {
  date: string | undefined;
}): SWRResponse<GetRecommendedProductResponse, AxiosError> => {
  const { regionCode } = useRegion();
  const { lang } = useLocale();
  const { data: user } = useUser();
  const selectedChildId = user?.selected_child_id;
  const isNewbie = useIsFirstLogin(selectedChildId);
  const canFetch = !!date && !!selectedChildId;

  return useSWR(
    canFetch ? ['getRecommendedProduct', regionCode, lang, selectedChildId, date] : null,
    ([_, regionCode, lang, child_id, date]) =>
      getRecommendedProduct({
        regionCode,
        lang,
        child_id,
        date,
        is_newbie: isNewbie,
      }),
  );
};
